import { useState } from 'react';

export type UseModalState = (
	initialState: boolean
) => {
	isOpen: boolean;
	open: () => void;
	close: () => void;
};

const useModalState: UseModalState = initialState => {
	const [isOpen, setOpen] = useState(initialState);

	const open = () => {
		setOpen(true);
	};

	const close = () => {
		setOpen(false);
	};

	return { isOpen, open, close };
};

export default useModalState;
